import React from "react";
import JBKycDocumentsComponent from "./JBKycDocumentsComponent";
import NITermsAndConditions from "../NITermsAndConditions";
import JBSecondaryESignComponent from "./JBSecondaryESignComponent";
import JBSecondaryCompletedComponent from "./JBSecondaryCompletedComponent";

interface JointIndividualOnlineViewerKycStepContentProps {
  activeStep: number;
  bidderUuid: any;
  bidder: any;
  setActiveStep: any;
  init: any;
  offlinePaymentValidation: boolean;
  stepsTitles: Array<{ label: string; value: string }>;
}

export default function JointIndividualOnlineViewerKycStepContent({
  activeStep,
  bidderUuid,
  bidder,
  setActiveStep,
  init,
  offlinePaymentValidation,
  stepsTitles,
}: JointIndividualOnlineViewerKycStepContentProps) {
  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <JBKycDocumentsComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 1:
        return (
          <NITermsAndConditions
            bidderUuid={bidderUuid}
            bidder={bidder}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 2:
        return (
          <JBSecondaryESignComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 3:
        return (
          <JBSecondaryCompletedComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="p-2 md:p-4 bg-white">
      {renderStepContent()}
    </div>
  );
}

